// extracted by mini-css-extract-plugin
export var label = "_d2-5";
export var slideContainer = "_d2-0";
export var slider = "_d2-1";
export var sliderLg = "_d2-4";
export var sliderMd = "_d2-3";
export var sliderSm = "_d2-2";